/**
 * Standard Actions configuration for Dawn.
 *
 * Storefront Renderer injects the Shopify Standard Actions bundle
 * (`window.Shopify.actions.{updateCart,openCart,getCart,…}`).
 *
 * updateCart is intentionally NOT configured here. Tally's cart editor
 * (theme app extension block, `enable_cart_editor: true`) configures its
 * own handler for `Shopify.actions.updateCart`, and the Standard Actions
 * API only supports one owner per action. Having this file *and* Tally
 * both call `.configure()` on the same handler created a load-order
 * race — whichever configure() call resolved last silently won,
 * producing intermittent "Cannot find variant" checkout failures across
 * every Tally-configured product. Pulled 2026-08-02 so Tally's own
 * handler is the sole owner of updateCart. Revisit only after
 * confirming with Tally how the two can coexist.
 *
 *   - openCart — opens <cart-drawer>; falls back to /cart. Unrelated to
 *     the updateCart race, left in place.
 *   - updateCart, getCart, etc. — left on whichever handler the last
 *     script to configure() them installs (currently Tally's).
 */

function initStandardActions() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.openCart.configure({
    async handler(defaultHandler) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      return defaultHandler();
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  initStandardActions();
} else {
  document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });
}
